import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendCasosActivosPorContratoId,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_Json from "../../../dataJson/casosArchivadosAllContratos.json";
import {
  formatDescripcion,
  formatearMensajeBackend,
  ordenarCasosBackend,
  shouldRenderTicket,
} from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";

interface State {
  listaCasosArchivadosAllContratos: any[];
  status: TypeStatus;
  processDefinitionIdDisplayName: string;
  processDefinitionIdVersion: string;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  listaCasosArchivadosAllContratos: [],
  processDefinitionIdDisplayName: "",
  processDefinitionIdVersion: "",
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
};
interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const listaCasosArchivadosAllContratosSlice = createSlice({
  name: "listaCasosArchivadosAllContratos",
  initialState,
  reducers: {
    setListaCasosArchivadosAllContratosPaginado: (
      state,
      action: PayloadAction<{ casos: any[]; numPagina: number }>,
    ) => {
      const { casos, numPagina } = action.payload;

      // Si la página es 1, reemplazamos los datos, si no, concatenamos con los existentes
      if (numPagina === 0) {
        state.listaCasosArchivadosAllContratos = casos;
      } else {
        state.listaCasosArchivadosAllContratos = [
          ...state.listaCasosArchivadosAllContratos,
          ...casos,
        ];
      }
    },
    setListaCasosArchivadosAllContratos: (
      state,
      action: PayloadAction<{ casos: any[]; numPagina: number }>,
    ) => {
      const { casos, numPagina } = action.payload;

      // Si la página es 1, reemplazamos los datos, si no, concatenamos con los existentes
      if (numPagina === 0) {
        state.listaCasosArchivadosAllContratos = casos;
      } else {
        state.listaCasosArchivadosAllContratos = [
          ...state.listaCasosArchivadosAllContratos,
          ...casos,
        ];
      }
    },

    getListaCasosArchivadosAllContratos: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state.listaCasosArchivadosAllContratos = action.payload;
    },
    setClearListaCasosArchivadosAllContratos: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setProcessDefinitionIdDisplayName: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.processDefinitionIdDisplayName = action.payload;
    },
    setProcessDefinitionIdVersion: (state, action: PayloadAction<string>) => {
      state.processDefinitionIdVersion = action.payload;
    },
  },
});
const procesarCasosArchivadosAllContratosPaginado = async (casos: any[]) => {
  return await Promise.all(
    casos.map(async (caso) => {
      const {
        Prioridad,
        alarma,
        descripcion,
        ci,
        Usuario,
        NombreContrato,
        ticketRedmine,
      } = caso;
      let partesResumen = [];
      if (alarma) {
        partesResumen.push(`Titulo: ${alarma}`);
      }
      if (descripcion) {
        const value = formatDescripcion(descripcion);
        partesResumen.push(`Descripción: ${value}`);
      }
      if (ci) {
        partesResumen.push(`Ci: ${ci}`);
      }
      if (Prioridad) {
        partesResumen.push(`Prioridad: ${Prioridad}`);
      }
      if (Usuario) {
        partesResumen.push(`Usuario: ${Usuario}`);
      }
      if (NombreContrato) {
        partesResumen.push(`Contrato: ${NombreContrato}`);
      }

      const renderTicketRedmine = shouldRenderTicket(ticketRedmine);

      if (renderTicketRedmine) {
        partesResumen.push(`Ticket Redmine Nro: ${ticketRedmine}`);
      }
      const resumen =
        partesResumen.length > 0
          ? partesResumen.join("\n\n")
          : "No pudimos obtener los datos del caso";

      return {
        ...caso,
        resumen,
      };
    }),
  );
};
const handleLocalhostArchivedMock = async (
  datos: any[],
  dispatch: any,
  NumPagina: number,
  Cantidad: number,
  ordenarCasosBackend: (a: any, b: any) => number,
  formatearMensajeBackend: (mensaje: string) => string,
  mock_Json: any,
): Promise<AxiosResponse> => {
  dispatch(setIsLoading(true));
  let response: AxiosResponse<any> = defaultResp;
  response.data = mock_Json;

  let ordenarLista = [...response.data.Data].sort(ordenarCasosBackend);

  let listaFormateada =
    await procesarCasosArchivadosAllContratosPaginado(ordenarLista);
  // Actualizar el estado con los casos archivados formateados
  dispatch(
    setListaCasosArchivadosAllContratosPaginado({
      casos: listaFormateada,
      numPagina: NumPagina,
    }),
  );
  dispatch(setIsLoading(false));
  dispatch(setStatus("succeeded"));
  dispatch(setSuccess(response.data.Success));

  if (!response.data) {
    response.data = { Data: [] }; // Inicializa data si es undefined
  }

  response.data.Data = listaFormateada;
  return response.data;
};

export const setBackendListaCasosArchivadosAllContratosPaginado =
  (
    IdCliente: number,
    IdContrato: number,
    TipoTicket: number, // 0 para Activos, 1 para inactivos
    IdCategoria: number,
    Cantidad: number, //2, // 0 para traer todos
    NumPagina: number,
  ): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));
      if (getCurrentDomain() === "localhostCambiar") {
        return await handleLocalhostArchivedMock(
          [],
          dispatch,
          NumPagina,
          Cantidad,
          ordenarCasosBackend,
          formatearMensajeBackend,
          mock_Json,
        );
      }
      try {
        let response: AxiosResponse = defaultResp;
        response = await BackendCasosActivosPorContratoId(
          IdCliente, // 0 para todos los clientes
          IdContrato, // cero para traer de todos los contratos
          TipoTicket, // 0 para Activos, 1 para inactivos
          IdCategoria,
          Cantidad, //2, // 0 para traer todos
          NumPagina,
        );

        const isError =
          response.data?.Success === false ||
          (response.data?.ResultadoSolicitud !== undefined &&
            response.data?.ResultadoSolicitud !== 200);

        if (isError) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          let ordenarLista = [...(response.data.Data || [])].sort(
            ordenarCasosBackend,
          );
          let listaFormateada =
            await procesarCasosArchivadosAllContratosPaginado(ordenarLista);
          dispatch(
            setListaCasosArchivadosAllContratosPaginado({
              casos: listaFormateada,
              numPagina: NumPagina,
            }),
          );

          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
          if (!response.data) {
            response.data = { Data: [] };
          }
          response.data.Data = listaFormateada;
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setSuccess(false));
        dispatch(setStatus("failed"));

        if (error.response?.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        } else if (error.response) {
          // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
          console.error(
            "Error de servidor:",
            error.response.status,
            error.response.data,
          );

          const errorData = error.response.data;
          const mensajeBackend = errorData?.Mensaje;
          const resultadoSolicitud = errorData?.ResultadoSolicitud;

          if (
            mensajeBackend &&
            (resultadoSolicitud !== 200 || errorData?.Success === false)
          ) {
            dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
          } else {
            dispatch(
              setMensaje(
                `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
              ),
            );
          }
        } else if (error.request) {
          console.error("Error de conexión:", error.message);
          dispatch(
            setMensaje(
              "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
            ),
          );
        } else {
          console.error("Error de red o solicitud:", error.message);
          dispatch(
            setMensaje(
              "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
            ),
          );
        }
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
        if (getCurrentDomain() === "localhost") {
          dispatch(setIsLoading(true));
          let response: AxiosResponse<any> = defaultResp;
          response.data = mock_Json;

          const mockData: any = mock_Json;
          const isErrorMock =
            mockData?.Success === false ||
            (mockData?.ResultadoSolicitud !== undefined &&
              mockData?.ResultadoSolicitud !== 200);

          if (isErrorMock) {
            dispatch(setIsLoading(false));
            dispatch(setStatus("failed"));
            dispatch(setSuccess(false));
          } else {
            let ordenarLista = [...(response.data.Data || [])].sort(
              ordenarCasosBackend,
            );

            let listaFormateada =
              await procesarCasosArchivadosAllContratosPaginado(ordenarLista);

            dispatch(
              setListaCasosArchivadosAllContratosPaginado({
                casos: listaFormateada,
                numPagina: NumPagina,
              }),
            );

            dispatch(setIsLoading(false));
            dispatch(setStatus("succeeded"));
            dispatch(setSuccess(true));

            if (!response.data) {
              response.data = { Data: [] };
            }

            response.data.Data = listaFormateada;
          }
          dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
          const mock401 = await import("../../../dataJson/401.json");
          if (mock401.status === 401) {
            dispatch(setStatus("noAutorice"));
            dispatch(
              setMensaje(
                formatearMensajeBackend(
                  "Tu sesión ha expirado. Vuelve a iniciar sesión",
                ),
              ),
            );
          }
        }
      }
    };

export const setBackendListaCasosArchivadosAllContratos =
  (
    TipoTicket: number, // 0 para Activos, 1 para inactivos
    Cantidad: number, //2, // 0 para traer todos
    IdCategoria: number,
    NumPagina: number,
    datos: any[],
  ): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));
      if (getCurrentDomain() === "localhost") {
        return await handleLocalhostArchivedMock(
          datos,
          dispatch,
          NumPagina,
          Cantidad,
          ordenarCasosBackend,
          formatearMensajeBackend,
          mock_Json,
        );
      }
      try {
        let allData: any[] = [];
        let response: AxiosResponse = defaultResp;
        const contratosPromises = datos.map(async (contrato) => {
          const { cliente, IdContrato } = contrato;
          const { IdCliente } = cliente;

          if (IdCliente) {
            response = await BackendCasosActivosPorContratoId(
              IdCliente,
              IdContrato,
              TipoTicket, // 0 para Activos, 1 para inactivos
              IdCategoria,
              Cantidad, //2, // 0 para traer todos
              NumPagina,
            );
            if (response.data?.Data) {
              allData = [...allData, ...response.data.Data];
            }
          }
        });

        await Promise.all(contratosPromises);

        const isError =
          response.data?.Success === false ||
          (response.data?.ResultadoSolicitud !== undefined &&
            response.data?.ResultadoSolicitud !== 200);

        if (isError) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          let ordenarLista = allData.sort(ordenarCasosBackend);
          let listaFormateada =
            await procesarCasosArchivadosAllContratosPaginado(ordenarLista);
          dispatch(
            setListaCasosArchivadosAllContratos({
              casos: listaFormateada,
              numPagina: NumPagina,
            }),
          );

          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
          if (!response.data) {
            response.data = { Data: [] };
          }

          response.data.Data = listaFormateada;
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setSuccess(false));
        dispatch(setStatus("failed"));

        if (error.response?.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        } else if (error.response) {
          // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
          console.error(
            "Error de servidor:",
            error.response.status,
            error.response.data,
          );

          const errorData = error.response.data;
          const mensajeBackend = errorData?.Mensaje;
          const resultadoSolicitud = errorData?.ResultadoSolicitud;

          if (
            mensajeBackend &&
            (resultadoSolicitud !== 200 || errorData?.Success === false)
          ) {
            dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
          } else {
            dispatch(
              setMensaje(
                `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
              ),
            );
          }
        } else if (error.request) {
          console.error("Error de conexión:", error.message);
          dispatch(
            setMensaje(
              "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
            ),
          );
        } else {
          console.error("Error de red o solicitud:", error.message);
          dispatch(
            setMensaje(
              "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
            ),
          );
        }
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
        if (getCurrentDomain() === "localhost") {
          dispatch(setIsLoading(true));
          let allData: any[] = [];
          let response: AxiosResponse<any> = defaultResp;
          response.data = mock_Json;
          for (const contrato of datos) {
            const { cliente } = contrato;
            const { IdCliente } = cliente;
            if (IdCliente) {
              allData = [...allData, ...(response.data.Data || [])];
            }
          }

          const mockData: any = mock_Json;
          const isErrorMock =
            mockData?.Success === false ||
            (mockData?.ResultadoSolicitud !== undefined &&
              mockData?.ResultadoSolicitud !== 200);

          if (isErrorMock) {
            dispatch(setIsLoading(false));
            dispatch(setStatus("failed"));
            dispatch(setSuccess(false));
          } else {
            let ordenarLista = [...allData];
            ordenarLista.sort(ordenarCasosBackend);
            let listaFormateada =
              await procesarCasosArchivadosAllContratosPaginado(ordenarLista);
            dispatch(
              setListaCasosArchivadosAllContratos({
                casos: listaFormateada,
                numPagina: NumPagina,
              }),
            );
            dispatch(setIsLoading(false));
            dispatch(setStatus("succeeded"));
            dispatch(setSuccess(true));
            if (!response.data) {
              response.data = { Data: [] };
            }
            response.data.Data = listaFormateada;
          }
          dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
          const mock401 = await import("../../../dataJson/401.json");
          if (mock401.status === 401) {
            dispatch(setStatus("noAutorice"));
            dispatch(
              setMensaje(
                formatearMensajeBackend(
                  "Tu sesión ha expirado. Vuelve a iniciar sesión",
                ),
              ),
            );
          }
        }
      }
    };

export const setBackendClearListaCasosArchivadosAllContratos =
  (): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));
      try {
        let response: AxiosResponse = defaultResp;
        dispatch(
          setListaCasosArchivadosAllContratos({
            casos: [],
            numPagina: 0,
          }),
        );
        dispatch(setIsLoading(false));
        dispatch(setStatus("idle"));
        dispatch(setSuccess(false));
        dispatch(setMensaje(""));
        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
      }
    };

export const {
  setListaCasosArchivadosAllContratosPaginado,
  setListaCasosArchivadosAllContratos,
  getListaCasosArchivadosAllContratos,
  setClearListaCasosArchivadosAllContratos,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
  setError,
  setProcessDefinitionIdDisplayName,
  setProcessDefinitionIdVersion,
} = listaCasosArchivadosAllContratosSlice.actions;

export default listaCasosArchivadosAllContratosSlice.reducer;
